import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Body } from 'breeze-intelligence-kit';
import { useSmartFillModal } from './useSmartFillModal/useSmartFillModal';
import { ModalBulk } from '../../ModalBulk/ModalBulk';
import { FillOption } from '../../FillOption';
import { SmartPropertyInfo } from '../../SmartPropertyInfo';
import { SmartFillPanelSummary } from '../SmartFillPanelUsage';
import { useCreditCheck } from 'policy-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MODAL_MIN_BLOCK_SIZE = '14rem';
export const SmartFillModalContent = ({
  isOpen,
  onClose,
  onCloseComplete
}) => {
  const {
    estimatedTotal,
    fillOption,
    isLoading,
    onEnrich,
    onSetFillOption,
    recordsToFill
  } = useSmartFillModal();
  const action = 'SMART_PROPERTY_RUN';
  const {
    isAuthorized
  } = useCreditCheck({
    action,
    numberOfOperations: estimatedTotal
  });
  return /*#__PURE__*/_jsxs(ModalBulk, {
    isLoading: isLoading,
    isOpen: isOpen,
    onClose: onClose,
    onCloseComplete: onCloseComplete,
    children: [/*#__PURE__*/_jsx(ModalBulk.Header, {
      children: /*#__PURE__*/_jsx(ModalBulk.Heading, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartFillModal.title"
        })
      })
    }), /*#__PURE__*/_jsxs(ModalBulk.Body, {
      minBlockSize: MODAL_MIN_BLOCK_SIZE,
      children: [/*#__PURE__*/_jsx(Body, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "smartFillModal.body",
          options: {
            count: recordsToFill
          }
        })
      }), /*#__PURE__*/_jsx(SmartPropertyInfo, {}), /*#__PURE__*/_jsx(FillOption, {
        onChange: onSetFillOption,
        value: fillOption
      }), /*#__PURE__*/_jsx(ModalBulk.UsageEstimate, {
        action: action,
        numberOfOperations: estimatedTotal
      }), /*#__PURE__*/_jsx(ModalBulk.Usage, {}), /*#__PURE__*/_jsxs(ModalBulk.DividerSection, {
        children: [/*#__PURE__*/_jsx(ModalBulk.UsageDisclaimer, {}), /*#__PURE__*/_jsx(SmartFillPanelSummary, {
          recordCount: recordsToFill,
          smartPropertyCount: 1
        })]
      })]
    }), /*#__PURE__*/_jsx(ModalBulk.Footer, {
      children: /*#__PURE__*/_jsxs(ModalBulk.FooterActions, {
        children: [/*#__PURE__*/_jsx(ModalBulk.ButtonPrimary, {
          disabled: isLoading,
          isLocked: !isAuthorized,
          onClick: onEnrich,
          type: "submit",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "smartFillModal.callToAction"
          })
        }), /*#__PURE__*/_jsx(ModalBulk.ButtonCancel, {
          onClick: onClose
        })]
      })
    })]
  });
};